import styled from "styled-components";

export const StyledWorkers = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledWorkersContent = styled.div`
    padding: 40px;
    height: 100%;
`;